import { render, staticRenderFns } from "./UserAgreement.vue?vue&type=template&id=5a9a8a24&scoped=true&"
import script from "./UserAgreement.vue?vue&type=script&lang=js&"
export * from "./UserAgreement.vue?vue&type=script&lang=js&"
import style0 from "./UserAgreement.vue?vue&type=style&index=0&id=5a9a8a24&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9a8a24",
  null
  
)

export default component.exports